class MainProduct extends HTMLElement {
  connectedCallback() {
    this.productHandle = this.dataset.productHandle;
    this.sectionId = this.dataset.sectionId;

    // Subscribe & Save is the default; only an explicit one-time choice opts out
    this.prefersOneTime = !!this.querySelector("#one-time-purchase:checked") &&
      !!this.querySelector("#subscribe-purchase");
    this.rememberSellingPlan();

    this.addVariantChangeEvents();
    this.addSubscribeChangeEvents();
  }

  async updateProductDetailsHTML() {
    const url = new URL(window.location);
    const variantParam = url.searchParams.get("variant")
      ? `variant=${url.searchParams.get("variant")}`
      : "";
    const sellingPlanParam = url.searchParams.get("selling_plan")
      ? `&selling_plan=${url.searchParams.get("selling_plan")}`
      : "";
    const focusEl = document.activeElement;

    const orderFrequencyEl = this.querySelector("#pdp-order-frequency");
    const addCartEl = this.querySelector("#pdp-add-cart");
    const packSizeEl = this.querySelector("#pdp-pack-size");

    const rawPathWithParams = `/products/${this.productHandle}?sections=${this.sectionId}&${variantParam}${sellingPlanParam}`;
    const rawResponse = await fetch(rawPathWithParams);
    const response = await rawResponse.json();

    const mainProductSubscriptionEl = response[this.sectionId];
    const element = this.htmlToElement(mainProductSubscriptionEl);

    if (orderFrequencyEl && element) {
      const newOrderFrequencyEl = element.querySelector("#pdp-order-frequency");
      if (newOrderFrequencyEl)
        orderFrequencyEl.innerHTML = newOrderFrequencyEl.innerHTML;
    }

    if (addCartEl)
      addCartEl.innerHTML = element.querySelector("#pdp-add-cart").innerHTML;
    if (packSizeEl)
      packSizeEl.innerHTML = element.querySelector("#pdp-pack-size").innerHTML;

    // The selected variant may not offer the requested plan, so drop it from the URL once the server falls back to one-time
    if (url.searchParams.has("selling_plan") && !this.querySelector("#subscribe-purchase:checked")) {
      url.searchParams.delete("selling_plan");
      window.history.replaceState({}, "", url);
    }

    this.rememberSellingPlan();
    this.addVariantChangeEvents();
    this.addSubscribeChangeEvents();

    if (focusEl && focusEl.id) {
      const nextFocus = document.getElementById(focusEl.id);
      if (nextFocus) nextFocus.focus();
    }
  }

  addVariantChangeEvents() {
    const variantsSelect = this.querySelectorAll("[name='variant-select']");
    if (!variantsSelect.length) return;

    variantsSelect.forEach((option) => {
      option.addEventListener("change", () => {
        const url = new URL(window.location);
        url.searchParams.set("variant", option.value);

        // Keep the shopper on Subscribe & Save when switching pack size, unless they chose one-time.
        // The server maps the plan to the new variant's own plan, or falls back to one-time.
        if (this.prefersOneTime || !this.lastSellingPlanId) {
          url.searchParams.delete("selling_plan");
        } else {
          url.searchParams.set("selling_plan", this.lastSellingPlanId);
        }
        window.history.replaceState({}, "", url);
        this.updateProductDetailsHTML();
      });
    });
  }

  rememberSellingPlan() {
    const subscribeInput = this.querySelector("#subscribe-purchase");
    const fieldset = this.querySelector("[data-default-selling-plan-id]");
    const planId =
      (subscribeInput && subscribeInput.dataset.sellingPlanId) ||
      (fieldset && fieldset.dataset.defaultSellingPlanId);

    if (planId) this.lastSellingPlanId = planId;
  }

  htmlToElement(html) {
    const template = document.createElement("template");
    template.innerHTML = html.trim();
    return template.content.firstChild;
  }

  addSubscribeChangeEvents() {
    const purchaseOptions = this.querySelectorAll("[name='purchase-options']");
    const selectSellingPlan = this.querySelector("#selling-plans");

    if (selectSellingPlan) {
      selectSellingPlan.addEventListener("change", () => {
        const url = new URL(window.location);
        url.searchParams.set("selling_plan", selectSellingPlan.value);
        window.history.replaceState({}, "", url);
        this.updateProductDetailsHTML();
      });
    }

    if (!purchaseOptions) return;

    purchaseOptions.forEach((option) => {
      option.addEventListener("change", () => {
        const url = new URL(window.location);

        this.prefersOneTime = option.id !== "subscribe-purchase";

        if (option.id === "subscribe-purchase") {
          if (option.dataset.sellingPlanId) {
            url.searchParams.set("selling_plan", option.dataset.sellingPlanId);
          }
        } else {
          url.searchParams.delete("selling_plan");
        }

        window.history.replaceState({}, "", url);
        this.updateProductDetailsHTML();
      });
    });
  }
}

customElements.define("main-product", MainProduct);
